module.exports = __webpack_public_path__ + "img/logo.bc4d111a.png";